export interface IPermission {
  permissionId: number;
  permissionName: string;
  canAccess: boolean;
  canEdit: boolean;
}

export interface IPermissionMap {
  permissionId: number;
  permissionName: string;
  routerName?: string; // map to vue-router name
}

export type IFullPermission = IPermission & IPermissionMap;

export interface IFetchPermission {
  permission_id: number;
  permission_name: string;
  can_access: boolean;
  can_edit: boolean;
}

export function transformPermission(data: IFetchPermission): IPermission {
  return {
    permissionId: data.permission_id,
    permissionName: data.permission_name,
    canAccess: data.can_access,
    canEdit: data.can_edit
  };
}
